import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'

import Breadcrumb from 'react-bootstrap/Breadcrumb'

import './breadcrumb.scss'

// Returns string with all the first letters capitalized after spaces
const format = (path) => {
  let formatted = path.charAt(0).toUpperCase()

  for (let i = 1; i < path.length; i++) {
    if (path[i] === '-') {
      formatted = `${formatted} ${path[i+1].toUpperCase()}`
      i++
    } else {
      formatted += path[i]
    }
  }

  return formatted
}

export default function BSCSBreadcrumb(props) {
  let path_list

  let current_path = ''
  let null_paths = []

  props.pathname[props.pathname.length - 1] === '/'
    ? path_list = props.pathname.split('/').slice(1, -1)
    : path_list = props.pathname.split('/').slice(1)

  return (
      <Breadcrumb className={props.className}>
        <Link to='/' className="breadcrumb-item">Home</Link>
        {path_list.map((path, index) => {
          if (
            path_list[path_list.length - 1] === path
            || null_paths.indexOf(path) > -1
          ) {
            current_path !== ''
              ? current_path = `${current_path}/${path}`
              : current_path = `/${path}`

            if (props.title && index === path_list.length - 1) {
              return (
                <div
                  key={`breadcrumb-${index}`}
                  className="breadcrumb-item active"
                >
                  {props.title}
                </div>
              )
            } else if (props.replace && path === props.replace[0]) {
              return (
                <div
                  key={`breadcrumb-${index}`}
                  className="breadcrumb-item active"
                >
                  {props.replace[1]}
                </div>
              )
            } else {
              return (
                <div
                  key={`breadcrumb-${index}`}
                  className="breadcrumb-item active">
                  {format(path)}
                </div>
              )
            }
          } else {
            current_path !== ''
              ? current_path = `${current_path}/${path}`
              : current_path = `/${path}`

            if (props.replace && path === props.replace[0]) {
              return (
                <Link
                  key={`breadcrumb-${index}`}
                  className="breadcrumb-item"
                  to={`${current_path}`}
                >
                  {props.replace[1]}
                </Link>
              )
            } else {
              return (
                <Link
                  key={`breadcrumb-${index}`}
                  className="breadcrumb-item"
                  to={`${current_path}`}
                >
                  {format(path)}
                </Link>
              )
            }
          }
        })}
      </Breadcrumb>
  )
}

BSCSBreadcrumb.propTypes = {
  className: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  title: PropTypes.string,
  replace: PropTypes.array
}

export { format }
